"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CopyableInput = exports.FormItem = exports.InlineForm = exports.NumberField = exports.MultiLinesStringField = exports.StringField = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var icons_1 = require("@ant-design/icons");
var TextArea_1 = __importDefault(require("antd/es/input/TextArea"));
var grid_1 = require("./grid");
function StringField(props) {
    var _a;
    return (0, jsx_runtime_1.jsx)(antd_1.Input, { value: (_a = props.binding.value) !== null && _a !== void 0 ? _a : "", onChange: function (evt) { var _a; return props.binding.update((_a = evt.target.value) !== null && _a !== void 0 ? _a : ""); }, placeholder: props.placeholder, prefix: props.prefix, suffix: props.suffix });
}
exports.StringField = StringField;
function MultiLinesStringField(props) {
    return (0, jsx_runtime_1.jsx)(TextArea_1.default, { value: props.binding.value, onChange: function (evt) { var _a; return props.binding.update((_a = evt.target.value) !== null && _a !== void 0 ? _a : ""); }, placeholder: props.placeholder, rows: props.rows });
}
exports.MultiLinesStringField = MultiLinesStringField;
function NumberField(props) {
    return (0, jsx_runtime_1.jsx)(antd_1.InputNumber, { value: props.binding.value, onChange: function (newValue) { return props.binding.update(newValue !== null && newValue !== void 0 ? newValue : 0); }, placeholder: props.placeholder, prefix: props.prefix, min: props.min, max: props.max, step: props.step });
}
exports.NumberField = NumberField;
function InlineForm(props) {
    return (0, jsx_runtime_1.jsx)(antd_1.Form, __assign({ layout: "inline" }, { children: props.children }));
}
exports.InlineForm = InlineForm;
function FormItem(props) {
    return (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ label: props.label, style: { margin: 0 } }, { children: props.children }));
}
exports.FormItem = FormItem;
function CopyableInput(props) {
    var _a = antd_1.notification.useNotification(), api = _a[0], contextHolder = _a[1];
    function onCopy() {
        return __awaiter(this, void 0, void 0, function () {
            var clipboard;
            return __generator(this, function (_a) {
                clipboard = navigator.clipboard;
                if (!clipboard) {
                    api.error({ message: "无法连接剪贴板" });
                    return [2 /*return*/];
                }
                try {
                    clipboard.writeText(props.value);
                    api.success({ message: props.successMessage });
                }
                catch (e) {
                    api.error({ message: "\u5199\u5165\u526A\u8D34\u677F\u65F6\u51FA\u73B0\u95EE\u9898" });
                    throw e;
                }
                return [2 /*return*/];
            });
        });
    }
    return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(grid_1.HStack, __assign({ layout: ["1fr", "auto"], spacing: 5 }, { children: [(0, jsx_runtime_1.jsx)(antd_1.Input, { value: props.value }), (0, jsx_runtime_1.jsx)(antd_1.Button, { icon: (0, jsx_runtime_1.jsx)(icons_1.CopyOutlined, {}), onClick: onCopy })] })), contextHolder] });
}
exports.CopyableInput = CopyableInput;
